import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['image']

  imageTargetConnected(img) {
    if (img.complete && img.naturalWidth > 0) {
      this.markLoadedInstantly()
    } else {
      img.addEventListener('load', this.markLoaded)
      img.addEventListener('error', this.markLoaded)
    }
  }

  imageTargetDisconnected(img) {
    img.removeEventListener('load', this.markLoaded)
    img.removeEventListener('error', this.markLoaded)
  }

  markLoadedInstantly() {
    this.element.classList.add('skeleton-loaded', 'skeleton-no-transition')
  }

  markLoaded = () => {
    this.element.classList.add('skeleton-loaded')
  }
}
